export default class Menu {

    constructor(menuToggle = '.menu-toggle') {
        this.rootHtml = document.querySelector('html');

        // Setup menu
        this.menuToggle = document.querySelector(menuToggle);
        this.menuItems = document.querySelectorAll('#menu .menu-primary .menu-item-has-children > a');

        // Init events only on mobile
        const styles = window.getComputedStyle(this.menuToggle);
        if(styles.display !== 'none') {
            this.addEvents();
        }
    }

    addEvents ()
    {
        // Toggle menu
        this.menuToggle.addEventListener('click', () => this.show());

        // SubMenus
        this.menuItems.forEach(el => {
            el.classList.add('is-closed'); // Close all at first
            el.addEventListener('click', (event) => {
                event.preventDefault();
                this.subMenuClick(event, el);
            });
        }, this);

        // watch scroll
        this.watchScroll();
    }

    // add to cart click


    // Toggle a submenu onClick
    subMenuClick (event, el) {
        // Close all items but toggle the one that was clicked
        this.menuItems.forEach(sub => {
            if(sub === el) {
                sub.classList.toggle('is-closed');
            } else {
                sub.classList.add('is-closed');
            }
        });
    }

    // Show-hide the menu
    show ()
    {
        this.rootHtml.classList.toggle('menu-on');
    }

    // Function that watch for scroll
    watchScroll () {

        // prepare throttle
        const throttle = ( callback, limit = 30, context = this ) => {
            let
                wait = false,
                timeout;

            return ( ...args ) => {
                if ( !wait ) {
                    callback.call( context, ...args );

                    wait = true;
                    clearTimeout( timeout );

                    timeout = setTimeout( function () {
                        wait = false;
                    }, limit );
                }
            }
        };

        // events
        // this.fixHeader();
        // window.addEventListener("scroll", throttle(this.fixHeader, 100));
    }

    fixHeader () {
        if (window.scrollY >= 100) {
            this.rootHtml.classList.add('has-scrolled');
        } else {
            this.rootHtml.classList.remove('has-scrolled');
        }
    }

}
